import { hover } from 'pobble-components/dist/jss-mixins'

const styles = ({ COLORS }) => ({
  center: {
    textAlign: 'center'
  },
  right: {
    textAlign: 'right'
  },
  usernameWrapper: {
    transition: 'color 0.3s',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    ...hover({
      color: COLORS.BLUE.NORMAL
    })
  },
  userNameHighlight: {
    color: COLORS.BLUE.NORMAL,
    fontWeight: 'bold'
  },
  updatingSpinner: {
    fontSize: '20px !important',
    margin: '8px 10px',
    display: 'inline-flex !important'
  },
  pendingRow: {
    '& td': {
      position: 'relative',
      '&:after': {
        content: '""',
        position: 'absolute',
        left: '0',
        top: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)'
      }
    }
  }
})

export default styles
